var _mask, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreditCard = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  stroke: "#fff",
  ref: ref
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "credit-card_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 14,
  x: 1,
  y: 5,
  rx: 1
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 14,
  x: 1,
  y: 5,
  strokeWidth: 3,
  mask: "url(#credit-card_svg__a)",
  rx: 1
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  strokeWidth: 1.5,
  d: "M2 10h20.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M5 15h1M9 15h1M13 15h1"
})));
SvgCreditCard.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreditCard);
export default ForwardRef;